import { SVGProps } from 'react'

export const DustButtonIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="30" height="23" viewBox="0 0 30 23" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.98 1.33L2.85 7.39L9.96 8.54L13.89 1.33L8.98 1.33ZM15.01 2.07L11.44 8.61H18.52L15.01 2.07ZM20.12 9.88L16.79 18.68L26.72 8.83L20.12 9.88ZM27.25 7.39L20.00 8.55L16.13 1.33H21.12L27.25 7.39ZM15.07 19.47L18.67 9.94H11.30L15.07 19.47ZM9.84 9.88L3.40 8.83L13.29 18.62L9.84 9.88ZM21.67 0L29.60 7.84L15.08 22.26L0.50 7.84L8.43 0L21.67 0Z"
        fill="url(#paint0_linear_2136_5384)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2136_5384"
          x1="15.05"
          y1="0.47"
          x2="15.05"
          y2="21.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
